import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { QrScan } from './Scan.js';
function ScanSignature({ className, onError, onScan, size, style }) {
    const _onScan = useCallback((signature) => signature && onScan({ signature: `0x${signature}` }), [onScan]);
    return (_jsx(QrScan, { className: className, onError: onError, onScan: _onScan, size: size, style: style }));
}
export const QrScanSignature = React.memo(ScanSignature);
